// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2cx1g","head":"ProcedureTableInfo_head__3oSys"};